import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import ImageWithSkeleton from '../../../../../../components/ImageWithSkeleton'
import { useTranslation } from 'react-i18next'

export default function TrackingAndContacts ({ race }) {
  const { t } = useTranslation('raceGuide')
  const trackingInfo = race?.trackingInfo || []

  // https://play.google.com/store/apps/details?id=net.livetrail.livetrail&pcampaignid=web_share
  // https://apps.apple.com/us/app/livetrail/id1205514003
  return (
    <Box sx={{ width: '100%', maxWidth: 800, py: 4 }}>
      {trackingInfo.map((item, index) => (
        <Box key={index} sx={{ mb: 4 }}>
          <Typography variant='h6' component='h3' gutterBottom sx={{ fontWeight: 'bold' }}>
            {item.title}
          </Typography>
          {item.image && (
          <Box sx={{ display: 'flex', my: 3 }}>
            <ImageWithSkeleton
              src={item.image}
              maxWidth='96px'
              square
              oneSize
              imageSx={{ borderRadius: 2 }}
            />
          </Box>
              )}

          {item.description && (
            <Box sx={{ mb: 3 }}>
              <Typography variant='body1' sx={{ whiteSpace: 'pre-line' }}>
                {item.description}
              </Typography>
            </Box>
          )}

          {item.numbers && (
            <Box sx={{ mt: 2 }}>
              <Typography variant='subtitle1' gutterBottom sx={{ fontWeight: 'medium' }}>
                {t('tracking.emergencyContacts')}
              </Typography>
              <List dense>
                {item.numbers.map((number, numIndex) => (
                  <ListItem key={numIndex} sx={{ py: 0.5 }}>
                    <ListItemText
                      primary={
                        <Link
                          href={`tel:${number.replace(/\s+/g, '')}`}
                          underline='hover'
                          sx={{ fontSize: '1.1rem', fontWeight: 'medium' }}
                        >
                          {number}
                        </Link>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}

          {index < trackingInfo.length - 1 && <Divider sx={{ my: 4 }} />}
        </Box>
      ))}
    </Box>
  )
}